// 微信分享（需要认证的公众号绑定JS接口安全域）
import wx from 'weixin-js-sdk';
import store from '../store';

function getQueryString (name) { // 根据字段看网址是否拼接&字符串
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return unescape(r[2]);
  }
  return null;
}

const defaultImg = window.location.protocol + '//cloudlive.zonekey.com.cn/static-server/pic/default/default.png';
const defaultParam = {
  title: '中庆云直播',
  desc: '用技术服务教育，用直播传递教育！',
  link: window.location.protocol + '//cloudlive.zonekey.com.cn/cloudlive/index.html#/homePage',
  img: defaultImg
};

function wxShare (param) {
  // 无参数传入时，默认分享路径为云直播首页
  if (!param) {
    param = defaultParam;
  }
  // 判断当前是否为从微信分享中跳转过来的
  let from = getQueryString('from');
  let appinstall = getQueryString('appinstall');
  let sec = getQueryString('sec');
  let timekey = getQueryString('timekey');
  // 修复二次分享没有图片和描述的问题
  if (from || appinstall || sec || timekey) {
    let url = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.hash;
    window.location.href = url;
  }
  // 微信签名配置
  wx.config(store.state.wxConfig);
  wx.ready(function () {
    // 分享到朋友圈
    wx.updateTimelineShareData({
      title: param.title + ((param.desc || param.desc.trim() !== 'null') ? '-' + param.desc : ''), // 分享标题
      link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: param.img, // 分享图标，图片位置
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    // 分享给微信好友
    wx.updateAppMessageShareData({
      title: param.title, // 分享标题
      desc: (param.desc || param.desc.trim() !== 'null') ? param.desc : '', // 分享描述
      link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: param.img,
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
  });
}

export { wxShare };



// WEBPACK FOOTER //
// ./src/utils/wetChat.js